import React from "react";
import { Box, Container, Paper, Typography } from "@mui/material";
import Nav from "./Nav";
import Footer from "./Footer";
export const ChildPolicy = () => {
  return (
    <Box>
      <Nav />
      <Box mt={12}>
        <Container maxWidth={false} sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
          <Paper elevation={6} sx={{ p: 4, mb: 6, width: "80%", mx: "auto" }}>
            <Box textAlign="center" mb={12} mt={5}>
                  <Typography
                    variant="h4"
                    component="h3"
                    gutterBottom
                    sx={{ fontFamily: "Montserrat" }}
                  >
                    Child Safety policy 
                  </Typography>
                  <div
                    className="text-left"
                    dangerouslySetInnerHTML={{
                      __html: `1. Introduction IND Matrimony is committed to ensuring a safe and respectful environment for individuals seeking matrimonial alliances. We have a zero-tolerance policy towards child sexual abuse and exploitation (CSAE) and strictly prohibit any related content or activities. This policy outlines our stance, reporting mechanisms, and enforcement measures.<br/><br/>
 
                                2. Prohibited Content & Activities Users are strictly prohibited from:
                                
                                Uploading, sharing, or distributing any content that involves or depicts CSAE.
                                
                                Creating profiles for minors or misrepresenting age.
                                
                                Engaging in or facilitating any form of child exploitation or abuse.
                                
                                Using our platform for grooming, solicitation, or predatory behavior.
                                
                                Encouraging or promoting any CSAE-related activities.<br/><br/>
                                
                                3. Reporting Mechanisms We encourage users to report any suspected CSAE violations immediately. Reports can be made through:
                                
                                The in-app reporting feature.
                                
                                Emailing our support team at support@indmatrimony.in.
                                
                                Contacting relevant law enforcement authorities.
                                
                                All reports are reviewed with the highest priority, and appropriate action is taken.<br/><br/>
                                
                                4. Enforcement & Actions If a user violates this policy, we will:
                                
                                Immediately remove the offending content.
                                
                                Suspend or permanently ban the user’s account.
                                
                                Report the violation to relevant authorities where applicable.
                                
                                Cooperate with law enforcement for investigations.<br/><br/>
                                
                                5. Collaboration with Authorities We work closely with law enforcement agencies, child protection organizations, and legal entities to combat CSAE. If required, we will provide necessary information to aid investigations and prevent harm.<br/><br/>
                                
                                6. User Education & Awareness We are dedicated to raising awareness about CSAE risks and safety practices. Our platform provides educational resources and safety guidelines to help users protect themselves and others.<br/><br/>
                                
                                7. Review & Updates This policy is subject to periodic review and updates to ensure compliance with the latest legal and safety standards. Any significant changes will be communicated to users through official channels.`,
                    }}
                  />
                
            </Box>
          </Paper>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
};
